<template>
  <div>
    <DashboardHeader title="Balances Brought Forward">
    <v-row class="mt-4 mx-2">
      <v-col :cols="isMobile ? 12 : 3">
        <vCardContainer title="Quickbooks Upload Balances" :bgColor="getThemeColor">
          <template #content>
        <vXLSX @json-data="getOpeningBalancesJsonData" class="mx-2"></vXLSX>
        </template>
        </vCardContainer>
      </v-col>
      <v-col :cols="isMobile ? 12 : 9">
      <v-card>
    <v-card-title>
      Opening Balances
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
          <v-data-table
            :search="search"
            v-if="isManager"
            :headers="computedArrearsHeaders"
            :items="computedArrears"
            :items-per-page="10"
          >
        <template v-slot:item.final="{item}">
          <v-text-field @change="updateField(item.sid,'final')" v-model="item.final"></v-text-field>
        </template>
        </v-data-table>
        </v-card>    
      </v-col>
    </v-row>
    
     
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title
            class="lighten-2"
            :style="{'background-color':getThemeColor,'color':'white'}"
          >Update Student Arrears</v-card-title>
          <v-text-field
            readonly
            class="mx-6 mt-4"
            label="Student ID"
            hide-details="auto"
            v-model="selectedStudentID"
          ></v-text-field>

          <v-text-field
            class="mx-6 mt-4"
            :label="'Amount in '+getCurrency"
            hide-details="auto"
            v-model="amount"
          ></v-text-field>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" @click="closeDialog()" persistent dark>Close</v-btn>
            <v-btn color="primary" @click="recordArrears()" dark>Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import finance from "@/plugins/finance";
import studentsjs from "@/plugins/students"
import DashboardHeader from "@/components/DashboardHeader.vue";
import vXLSX from '@/components/Legos/vXLSX.vue';
import vCardContainer from '@/components/Legos/vCardContainer.vue';

export default {
  components: { DashboardHeader,vXLSX ,vCardContainer},
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
     isMobile() {
      return this.$store.getters.isMobile;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    }
  },
  mounted() {
    this.getComputedArrears()
  },
  data: () => ({
    search:null,
    dialog: false,
    arrearId: 0,
    amount: 0,
    manualArrears: [],
    manualArrearsHeaders: [
      {
        text: "Student ID",
        align: "start",
        value: "sid"
      },
      { text: "Amount", value: "amount" },
      { text: "Action", value: "id" }
    ],
    selectedManualArrears: [],
    computedArrearsHeaders: [
      {
        text: "Student ID",
        align: "start",
        value: "sid"
      },
      { text: "Description", value: "description" },
      { text: "Year", value: "year" },
      { text: "Computed", value: "computed" },
      { text: "Final", value: "final" },
    ],
    computedArrears: [],
    selectedStudentID: null
  }),
  methods: {
    async getOpeningBalancesJsonData(openingBalancesJsonData) {

      this.$store.commit('setLoader', true)

      const sids = []
      const students = await studentsjs.getStudents()
      
      students.forEach(obj => {
        sids.push(obj.sid)
        sids.push('0'+obj.sid)
      })

      const openingBalances = openingBalancesJsonData.filter(op => {
        return sids.includes(op['Customer'])
      })

      openingBalances.forEach(opObj => {
        opObj.balance = Number(opObj['Balance Total'].replace(/\s/g, '').replace(',','.'))
      })
      
      axios.postDataWithToken('/auth/save-quickbooks-balances',
      {openingBalances},
      this.getAccessToken)
        .then(response => {
          if (response == 'success') {
             this.getComputedArrears()
          this.$toast.success('Quickbooks Opening Balances Successfully Uploaded!')
          } else {
          this.$toast.error('Oops, Something Went Wrong!')
          }
        this.$store.commit('setLoader',false)
      })
    },
    getManualArrears() { 
      this.$store.commit("setLoader", true);
      this.manualArrears = []
    axios
      .getData("/auth/get-manual-arrears", this.getAccessToken)
      .then(manualArrears => {
        manualArrears.forEach(arrear => {
          this.manualArrears.push({
            sid: arrear.sid,
            amount: axios.formatMoney(Number(arrear.amount)),
            id: arrear.id
          });
        });

        this.$store.commit("setLoader", false);
        this.getComputedArrears();
      });
    },
    getSelectedStudentID(sid) {
      this.selectedStudentID = sid;
    },
    editManualArrears(item) {
      this.selectedStudentID = item.sid;
      this.amount = item.amount;
      this.arrearId = item.id;
      this.dialog = true;
    },
    bulkDeleteArrears() {
      if (this.selectedManualArrears.length > 0) {
        if (confirm("Are You Sure You Want to Delete The Selected Items?")) {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/delete-selected-arrears",
              { ids: this.selectedManualArrears },
              this.getAccessToken
            )
            .then(manualArrears => {
              this.manualArrears = [];
              manualArrears.forEach(arrear => {
                this.manualArrears.push({
                  sid: arrear.sid,
                  amount: axios.formatMoney(Number(arrear.amount)),
                  id: arrear.id
                });
              });
              this.arrearId = 0;
              this.dialog = false;
              this.$store.commit("setLoader", false);
              this.getComputedArrears();
            });
        }
      } else {
        event.preventDefault();
        alert("You Must At Least Select One Item To Delete !");
      }
    },
    recordArrears() {
      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/save-manual-arrear",
          {
            sid: this.selectedStudentID,
            amount: this.amount,
            arrearId: this.arrearId
          },
          this.getAccessToken
        )
        .then(manualArrears => {
          this.manualArrears = [];
          manualArrears.forEach(arrear => {
            this.manualArrears.push({
              sid: arrear.sid,
              amount: axios.formatMoney(Number(arrear.amount)),
              id: arrear.id
            });
          });
          this.arrearId = 0;
          this.dialog = false;
          this.$store.commit("setLoader", false);
          this.getComputedArrears();
        });
    },
    closeDialog() {
      this.selectedStudentID = null;
      this.arrearId = 0;
      this.amount = null;
      this.dialog = false;
    },
    getComputedArrears() {
      this.$store.commit("setLoader", true);
      this.computedArrears = [];
      this.arrearId = 0;
      axios
        .getData("/auth/get-computed-arrears", this.getAccessToken)
        .then(computedArrears => {
          computedArrears.forEach(computedArrear => {
            this.computedArrears.push({
              sid: computedArrear.sid,
              description: computedArrear.final <= 0 ? 'Excess Carried Forward' : 'Arrears Carried Forward' ,
              year: computedArrear.year,
              computed:
                this.getCurrency +
                " " +
                axios.formatMoney(Math.abs(Number(computedArrear.computed))),
              final:
                this.getCurrency +
                " " +
                axios.formatMoney(Math.abs(Number(computedArrear.final))) 
            });
          });
          this.$store.commit("setLoader", false);
        });
    },
    updateField(sid, column) {
      let value = event.target.value;
      value = finance.stripCurrency(value)
      axios
        .postDataWithToken(
          "/auth/update-opening-balances",
          { table: "opening_balances", sid, column, value },
          this.getAccessToken
        )
        
    },
  }
};
</script>

<style>
</style>